
import { StatItem } from '@/Models'
import './stat-preview-card.scss'
import { formatStatValue } from '../stat-row/stat-row'

interface StatPreviewCardProps {
  item: StatItem
  isActive?: boolean
}

/** Renders one stat */
export function StatPreviewCard({ item, isActive = false }: StatPreviewCardProps) {
  const description = item.description.trim()

  const className = [
    'stat-preview-card',
    `stat-preview-card--${item.color}`,
    isActive ? 'stat-preview-card--active' : '',
    item.visible ? '' : 'stat-preview-card--hidden',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <article className={className}>
      {!item.visible && <span className='stat-preview-card__tag'>Hidden on landing page</span>}
      <p className='stat-preview-card__value'>{formatStatValue(item)}</p>
      <p
        className={
          description
            ? 'stat-preview-card__description'
            : 'stat-preview-card__description stat-preview-card__description--empty'
        }
      >
        {description || 'Description appears here'}
      </p>
    </article>
  )
}
